// extracted by mini-css-extract-plugin
export default {"main":"followUsSection_main__lnCX2","image":"followUsSection_image__V+2ZT","title":"followUsSection_title__0uu63"};